import wootConstants from 'dashboard/constants/globals';
import {
  isClosingReasonRequiredToResolve,
  isClosingReasonRequiredForSnooze,
} from './inbox';

const REQUIREMENT_CHECK_BY_STATUS = {
  [wootConstants.STATUS_TYPE.RESOLVED]: isClosingReasonRequiredToResolve,
  [wootConstants.STATUS_TYPE.SNOOZED]: isClosingReasonRequiredForSnooze,
};

export const isConversationStatusChangeBlocked = ({
  store,
  conversationId,
  status,
}) => {
  const requiresReason = REQUIREMENT_CHECK_BY_STATUS[status];
  if (!requiresReason) {
    return false;
  }

  const conversation = store.getters.getConversationById(conversationId);
  const inbox =
    conversation && store.getters['inboxes/getInbox'](conversation.inbox_id);

  return requiresReason(inbox);
};

export const splitConversationsByClosingReasonRequirement = (
  conversationIds,
  store,
  status
) => {
  const blockedIds = conversationIds.filter(conversationId =>
    isConversationStatusChangeBlocked({ store, conversationId, status })
  );
  const allowedIds = conversationIds.filter(
    conversationId => !blockedIds.includes(conversationId)
  );

  return { allowedIds, blockedIds };
};
